export default __webpack_public_path__ + "static/media/sa-title-en.853898c5.webp";